import React from 'react';
import { PROVENANCE_STYLES } from '../constants';

export default function ProvenanceBadge({ provenance, className = '' }) {
    const style = PROVENANCE_STYLES[provenance] || PROVENANCE_STYLES.self_selected;
    return (
        <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full ${style.bg} ${style.fg} ${className}`}>
            {style.label}
        </span>
    );
}
